howspace.widgets.textbox = {
    initView: widget => {
        // Empty for now.
    },
    destroyView: widget => {
        // Empty for now.
    },
    initEdit: widget => {
        // Empty for now.
    },
    destroyEdit: widget => {
        // Empty for now.
    }
};
